import { trackSource } from '@marketplace/helpers/source-tracking.js'
import { getVueReferrer } from '@marketplace/helpers/url.js'

// TODO share between current app and Nuxt?
const currentCategoryDepth = (to) => {
    const routePath = to.params?.pathMatch || ''
    const isFirstCharacter = routePath.charAt(0) === '/'
    const depth = isFirstCharacter
        ? routePath.replace(routePath.charAt(0), '')
        : routePath
    const currentCategoryDepth = depth ? depth.split('/').length : 0

    window.Store.currentCategoryDepth = currentCategoryDepth
}

/**
 * Remove the alerts from Laravel, eg. generic validation messages.
 */
function clearTwigAlerts() {
    const alert = document.querySelector('.js--twig-alert')

    if (alert) {
        alert.remove()
    }
}

/**
 * Copy/pasted for the current app.
 * @param {object} to
 * @param {object} from
 */
function setCustomHistory(to, from) {
    const vueReferrer = getVueReferrer(from)

    // recent 6 routes based on previous route or referrer
    to.meta.history = from.meta.history || []
    to.meta.crumbs = from.meta.crumbs || []

    if (from.name) {
        to.meta.crumbs.push({
            name: from.name,
            path: from.fullPath,
            ...(from?.params && { ...from.params }),
            ...(window.Store?.lastLandingPageName && {
                landingpage: window.Store.lastLandingPageName,
            }),
        })

        if (to.meta.crumbs.length > 3) {
            to.meta.crumbs.shift()
        }

        to.meta.history.push(from.fullPath)
        if (to.meta.history.length > 20) {
            to.meta.history.shift()
        }
    } else if (vueReferrer) {
        to.meta.history.push(vueReferrer)
    }

    window.Store.lastLandingPageName = ''
}

export default (context) => {
    const { router, store } = context.app

    router.afterEach(() => {
        window.Store?.initCheckoutTracking?.()
    })

    router.beforeEach((to, from, next) => {
        currentCategoryDepth(to)
        setCustomHistory(to, from)
        trackSource(to, from)

        if (to.name && from.name) {
            clearTwigAlerts()
        }

        // Get the path from the URL
        const url = from?.name ? from : to

        // Store it in Vuex
        store.commit('global/setPreviousUrl', url)

        next()
    })
}
